import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/pegamento.webp';
import screenshot_target from '../../../images/letterfunnel/sergepoppes.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Serge Poppes"
      firstname="Serge"
      companyname="Pegamento"
      competition="WeAreBrain en Codelevate"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/sergepoppes.js